export default "__VITE_ASSET__adcc787a__"